module.exports = __webpack_public_path__ + "static/media/loader-document.f9a5056b.gif";